import Footer from './components/footer';
import NavigationComponent from './components/navigationComponent';
import SEO from './components/SEO';
import TextSection from './components/textSection';
import { sectionEnum } from './sectionEnum';
import {
  PRACTICE_DESCRIPTION,
  PRACTICE_IMAGE,
  PRACTICE_KEYWORDS,
  PRACTICE_NAME,
  PRACTICE_STRUCTURED_DATA,
} from './seoConfig';

const Impressum = () => {
  const title = `${PRACTICE_NAME} | Impressum`;
  const description = `Impressum und Pflichtangaben von ${PRACTICE_NAME} in Hamburg-Bergedorf. ${PRACTICE_DESCRIPTION}`;

  return (
    <>
      <SEO
        title={title}
        description={description}
        path="/impressum"
        image={PRACTICE_IMAGE}
        keywords={PRACTICE_KEYWORDS}
        structuredData={PRACTICE_STRUCTURED_DATA}
        siteName={PRACTICE_NAME}
      />
      <NavigationComponent
        enums={[
          sectionEnum.WILLKOMMEN,
          sectionEnum.VERANSTALTUNGEN,
          sectionEnum.LEISTUNGEN,
          sectionEnum.TERMINE,
          sectionEnum.UEBER,
        ]}
      />
      <main>
        <TextSection enum={sectionEnum.IMPRESSUM} />
      </main>
      <Footer />
    </>
  );
};

export default Impressum;
